import Swiper from 'swiper/bundle';
import { updateSlidesInert } from '../utils/accessibility-swiper';

const getSwiperA11yMessages = () => {
	const locale = window.Shopify?.locale || document.documentElement.lang || 'uk';
	const isUk = locale === 'uk';

	return {
		enabled: true,
		slideLabelMessage: '',
		paginationBulletMessage: isUk ? 'Перейти до слайду {{index}}' : 'Перейти к слайду {{index}}',
		nextSlideMessage: isUk ? 'Наступний слайд' : 'Следующий слайд',
		prevSlideMessage: isUk ? 'Попередній слайд' : 'Предыдущий слайд',
	};
};

const syncSlidesInert = (swiper) => {
	window.requestAnimationFrame(() => {
		updateSlidesInert(swiper, 'visible');
	});
};

export function features() {
	let sliderEl = document.querySelector('.features .swiper');
	
	if (sliderEl) {
		let slider = new Swiper(sliderEl, {
			loop: false,
			speed: 500,
			watchSlidesProgress: true,
			pagination: {
				el: ".features .slider-pagination",
				bulletClass: 'slider-pagination__bullet',
				bulletActiveClass: 'slider-pagination__bullet--active',
				clickable: true
			},
			navigation: {
				prevEl: ".features .slider-controls__btn--prev",
				nextEl: ".features .slider-controls__btn--next",
			},
			a11y: getSwiperA11yMessages(),
			on: {
				init(swiper) {
					syncSlidesInert(swiper);
				},
				slideChange(swiper) {
					syncSlidesInert(swiper);
				},
				transitionEnd(swiper) {
					syncSlidesInert(swiper);
				},
				resize(swiper) {
					syncSlidesInert(swiper);
				},
				breakpoint(swiper) {
					syncSlidesInert(swiper);
				},
			},

			breakpoints: {
				100: {
					slidesPerView: 1.5,
					spaceBetween: 12
				},
				650: {
					slidesPerView: 2.2,
					spaceBetween: 16
				},
				900: {
					slidesPerView: 3,
					spaceBetween: 24
				},
				
				1024: {
					slidesPerView: 5,
					spaceBetween: 12
				},
				
			},
		});
	}
}
